import { defaultFill } from '../../utils/constants';
var muiPlusGlyph = {
    paths: [
        {
            path: 'M5.5,12 C5.5,12.4814815 5.89605735,12.869773 6.369773,12.869773 L11.130227,12.869773 L11.130227,17.630227 C11.130227,18.1039427 11.5262843,18.5 12,18.5 C12.4737157,18.5 12.869773,18.1039427 12.869773,17.630227 L12.869773,12.869773 L17.630227,12.869773 C18.1039427,12.869773 18.5,12.4814815 18.5,12 C18.5,11.5262843 18.1039427,11.130227 17.630227,11.130227 L12.869773,11.130227 L12.869773,6.369773 C12.869773,5.89605735 12.4737157,5.5 12,5.5 C11.5262843,5.5 11.130227,5.89605735 11.130227,6.369773 L11.130227,11.130227 L6.369773,11.130227 C5.89605735,11.130227 5.5,11.5262843 5.5,12 Z',
            fill: defaultFill,
        },
    ],
    title: 'Plus',
    width: 24,
    height: 24,
};
var muiPlus = {
    base: muiPlusGlyph,
};
export { muiPlus };
//# sourceMappingURL=plus.js.map